import { Collapse, Row, Col, Tag, Popconfirm, Table, message, notification, Tooltip, Space } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  dineroDisabledMask,
  ModalItem,
  ButtonItem,
} from "../../../../Components/Items";
import ModalMovimientoInventarioPdf from "../../MovimientosInventario/ModalMovimientoInventarioPdf/ModalMovimientoInventarioPdf";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import moment from "moment";

const { Panel } = Collapse;

class RecepcionesOrdenDeCompra extends Component {
  state = {
    loading: false,
    recepciones: [],
    seleccionPorRecepcion: {},
    modalPdfVisible: false,
    modalPdfMovimientoId: null,
    confirmacionVisible: false,
    confirmacionLoading: false,
    confirmacionData: null,
    recepcionAConfirmar: null,
    loteSeleccionVisible: false,
    loteSeleccionActual: null,
    loteSeleccionCola: [],
    seleccionesLotesAcumuladas: [],
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  onChangeSeleccion(recepcionId, insumosOrdenIds) {
    this.setState((prevState) => ({
      seleccionPorRecepcion: {
        ...prevState.seleccionPorRecepcion,
        [recepcionId]: insumosOrdenIds,
      },
    }));
  }

  cancelarSeleccionados(recepcion, confirmarDescuentoInventarioGeneral = false) {
    const insumosOrdenIds = this.state.seleccionPorRecepcion[recepcion._id] || [];
    if (insumosOrdenIds.length === 0) {
      message.error("Selecciona al menos un insumo para cancelar");
      return;
    }
    if (confirmarDescuentoInventarioGeneral) {
      this.setState({ confirmacionLoading: true });
    } else {
      this.setState({ loading: true });
    }
    axios
      .post(
        "ordenesdecompra/cancelarRecepcionOrdenDeCompra",
        {
          recepcionOrdenDeCompraId: recepcion._id,
          insumosOrdenIds,
          empresaId: this.props.empresaId,
          ...(confirmarDescuentoInventarioGeneral ? { confirmarDescuentoInventarioGeneral: true } : {}),
          ...(this.state.seleccionesLotesAcumuladas.length > 0
            ? { seleccionesLotes: this.state.seleccionesLotesAcumuladas }
            : {}),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Recepción cancelada");
          if (res.data.relacionesDesligadas > 0) {
            message.warn(
              "Se desligaron " +
              res.data.relacionesDesligadas +
              " relaciones de esta entrega con facturas. Revisa esas facturas si necesitas volver a ligarlas.",
              8
            );
          }
          this.setState(
            (prevState) => ({
              confirmacionLoading: false,
              confirmacionVisible: false,
              confirmacionData: null,
              recepcionAConfirmar: null,
              loteSeleccionVisible: false,
              loteSeleccionActual: null,
              loteSeleccionCola: [],
              seleccionesLotesAcumuladas: [],
              seleccionPorRecepcion: {
                ...prevState.seleccionPorRecepcion,
                [recepcion._id]: [],
              },
            }),
            () => this.consultarTodo()
          );
        } else if (res.data.success === 4) {
          const cola = res.data.insumosLotes || [];
          this.setState({
            loading: false,
            confirmacionLoading: false,
            recepcionAConfirmar: recepcion,
            loteSeleccionActual: cola[0] || null,
            loteSeleccionCola: cola.slice(1),
            loteSeleccionVisible: cola.length > 0,
          });
        } else if (res.data.success === 3) {
          this.setState({
            loading: false,
            confirmacionLoading: false,
            confirmacionVisible: true,
            confirmacionData: {
              message: res.data.message,
              detalle: res.data.detalle || [],
            },
            recepcionAConfirmar: recepcion,
          });
        } else if (res.data.success === 1) {
          this.setState({ loading: false, confirmacionLoading: false });
          notification.error({
            message: "Error",
            description: res.data.message || "No se pudo cancelar la recepción",
            duration: 8,
          });
        } else {
          this.setState({ loading: false, confirmacionLoading: false });
          message.error("Error al cancelar la recepción");
        }
      })
      .catch(() => {
        this.setState({ loading: false, confirmacionLoading: false });
        message.error("Error al cancelar la recepción");
      });
  }

  confirmarCancelacionConDescuentoInventario = () => {
    if (!this.state.recepcionAConfirmar) return;
    this.cancelarSeleccionados(this.state.recepcionAConfirmar, true);
  };

  cerrarConfirmacionCancelacion = () => {
    this.setState({
      confirmacionVisible: false,
      confirmacionData: null,
      recepcionAConfirmar: null,
    });
  };

  onElegirLotesCerrado = (lotesFiltrados) => {
    const { loteSeleccionActual, loteSeleccionCola, recepcionAConfirmar } = this.state;
    if (!lotesFiltrados || lotesFiltrados.length === 0) {
      this.setState({
        loteSeleccionVisible: false,
        loteSeleccionActual: null,
        loteSeleccionCola: [],
        seleccionesLotesAcumuladas: [],
        recepcionAConfirmar: null,
      });
      return;
    }
    const nuevaSeleccion = {
      entradaOriginalId: loteSeleccionActual.entradaOriginalId,
      lotes: lotesFiltrados.map((l) => ({ entradaId: l.entradaId, cantidadRequerida: l.cantidadRequerida })),
    };
    this.setState(
      (prevState) => ({
        seleccionesLotesAcumuladas: [...prevState.seleccionesLotesAcumuladas, nuevaSeleccion],
        loteSeleccionActual: loteSeleccionCola[0] || null,
        loteSeleccionCola: loteSeleccionCola.slice(1),
        loteSeleccionVisible: loteSeleccionCola.length > 0,
      }),
      () => {
        if (loteSeleccionCola.length === 0) {
          this.cancelarSeleccionados(recepcionAConfirmar);
        }
      }
    );
  };

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "ordenesdecompra/recepcionesOrdenDeCompra",
        { ordenId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ recepciones: Array.isArray(res.data) ? res.data : [] });
      });
    this.setState({ loading: false });
  }
  cerrarRecepcionesOrdenDeCompra() {
    this.props.cerrarRecepcionesOrdenDeCompra();
  }

  abrirPdfMovimiento(movimientoId) {
    this.setState({ modalPdfVisible: true, modalPdfMovimientoId: movimientoId });
  }

  cerrarPdfMovimiento() {
    this.setState({ modalPdfVisible: false, modalPdfMovimientoId: null });
  }

  estadoRecepcionTag(estado) {
    if (estado === 0) return <Tag color="red">Cancelada</Tag>;
    if (estado === 2) return <Tag color="orange">Parcialmente cancelada</Tag>;
    return <Tag color="green">Activa</Tag>;
  }

  render() {
    const { recepciones, seleccionPorRecepcion } = this.state;
    return (
      <ModalItem
        title="Recepciones Orden De Compra"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarRecepcionesOrdenDeCompra.bind(this)}
        paddingTop
      >
        {recepciones.length === 0 ? (
          <p>No se encontró ninguna recepción</p>
        ) : (
          <Collapse style={{ marginBottom: 10 }}>
            {recepciones.map((valueRecepcion) => {
              const insumosSeleccionables = (valueRecepcion.insumos || []).filter(
                (v) => v.estado !== 0 && !v.tieneAjusteCambiario && !v.tieneTraspasoOtroProyecto
              );
              const seleccionados = seleccionPorRecepcion[valueRecepcion._id] || [];
              const movimientosIds = (
                valueRecepcion.movimientosInventarioIds?.length
                  ? valueRecepcion.movimientosInventarioIds
                  : [valueRecepcion.movimientoInventarioId]
              ).filter(Boolean);
              const puedeVerMovimiento =
                this.props.permisoAccesoMovimientosInventario &&
                this.props.permisoVerMovimientosInventario;
              return (
                <Panel
                  extra={this.estadoRecepcionTag(valueRecepcion.estado)}
                  header={
                    moment(valueRecepcion.fecha).locale("es").format("ll") +
                    (valueRecepcion.codigoRemision ? " - " + valueRecepcion.codigoRemision : "")
                  }
                  key={valueRecepcion._id}
                >
                  <Row>
                    <Col span={24}>
                      <p>
                        Total proveedor: {dineroDisabledMask(valueRecepcion.totalProveedor || 0)}
                      </p>
                    </Col>
                  </Row>
                  {movimientosIds.length > 0 && (
                    <Row>
                      <Col span={24} style={{ marginBottom: 10 }}>
                        <Tooltip
                          title={
                            puedeVerMovimiento
                              ? null
                              : "No tiene permiso para ver movimientos de inventario"
                          }
                        >
                          <Space wrap>
                            {movimientosIds.map((movimientoId, index) => (
                              <ButtonItem
                                key={movimientoId}
                                icon={<EyeOutlined />}
                                disabled={!puedeVerMovimiento}
                                onClick={() => this.abrirPdfMovimiento(movimientoId)}
                              >
                                {movimientosIds.length > 1
                                  ? "Ver movimiento " + (index + 1)
                                  : "Ver movimiento"}
                              </ButtonItem>
                            ))}
                          </Space>
                        </Tooltip>
                      </Col>
                    </Row>
                  )}
                  <Table
                    size="small"
                    pagination={false}
                    rowKey={(record) => record.insumoOrdenId}
                    dataSource={valueRecepcion.insumos || []}
                    rowSelection={{
                      selectedRowKeys: seleccionados,
                      onChange: (keys) => this.onChangeSeleccion(valueRecepcion._id, keys),
                      getCheckboxProps: (record) => ({
                        disabled:
                          record.estado === 0 ||
                          record.tieneAjusteCambiario ||
                          record.tieneTraspasoOtroProyecto,
                      }),
                    }}
                    columns={[
                      {
                        title: "Insumo",
                        key: "insumo",
                        render: (record) => record.nombreInsumo || record.insumoOrdenId,
                      },
                      {
                        title: "Cantidad",
                        dataIndex: "cantidad",
                        key: "cantidad",
                        align: "right",
                      },
                      {
                        title: "Estatus",
                        key: "estatus",
                        render: (record) => {
                          if (record.estado === 0) return <Tag color="red">Cancelado</Tag>;
                          if (record.tieneAjusteCambiario)
                            return <Tag color="orange">No cancelable (ajuste cambiario)</Tag>;
                          if (record.tieneTraspasoOtroProyecto)
                            return <Tag color="orange">No cancelable (traspaso a otro proyecto)</Tag>;
                          return <Tag color="green">Activo</Tag>;
                        },
                      },
                    ]}
                    style={{ marginBottom: 10 }}
                  />
                  {insumosSeleccionables.length > 0 && (
                    <Popconfirm
                      title="¿Seguro que quieres cancelar los insumos seleccionados de esta recepción?"
                      onConfirm={() => this.cancelarSeleccionados(valueRecepcion)}
                      okText="Si"
                      cancelText="No"
                      disabled={!this.props.permisoCancelarRecepcionOrdenDeCompra}
                    >
                      <Tooltip
                        title={
                          this.props.permisoCancelarRecepcionOrdenDeCompra
                            ? null
                            : "No tiene permiso para cancelar recepciones"
                        }
                      >
                        <ButtonItem
                          rojo
                          type="primary"
                          disabled={
                            seleccionados.length === 0 ||
                            !this.props.permisoCancelarRecepcionOrdenDeCompra
                          }
                        >
                          Cancelar seleccionados
                        </ButtonItem>
                      </Tooltip>
                    </Popconfirm>
                  )}
                </Panel>
              );
            })}
          </Collapse>
        )}
        <ModalMovimientoInventarioPdf
          visible={this.state.modalPdfVisible}
          movimientoId={this.state.modalPdfMovimientoId}
          onCancel={this.cerrarPdfMovimiento.bind(this)}
        />
        <ModalItem
          title="Confirmar cancelación de recepción"
          visible={this.state.confirmacionVisible}
          spinning={this.state.confirmacionLoading}
          onCancel={this.cerrarConfirmacionCancelacion}
          onOk={this.confirmarCancelacionConDescuentoInventario}
          okText="Continuar"
          cancelText="Cancelar"
          footer
          paddingTop
          width={window.innerWidth > 1000 ? "55%" : "95%"}
        >
          {this.state.confirmacionData && (
            <>
              <p style={{ marginTop: 10 }}>{this.state.confirmacionData.message}</p>
              {this.state.confirmacionData.detalle.length > 0 && (
                <Table
                  size="small"
                  pagination={false}
                  rowKey={(record, index) => `${record.insumoId || ""}-${index}`}
                  dataSource={this.state.confirmacionData.detalle}
                  columns={[
                    {
                      title: "Insumo",
                      key: "insumo",
                      render: (record) => `${record.clave || ""} - ${record.descripcion || ""}`,
                    },
                    {
                      title: "Cantidad",
                      dataIndex: "cantidad",
                      key: "cantidad",
                      align: "right",
                    },
                    {
                      title: "Costo original",
                      dataIndex: "costoOriginal",
                      key: "costoOriginal",
                      align: "right",
                      render: (costo) => dineroDisabledMask(costo || 0),
                    },
                    {
                      title: "Costo actual",
                      dataIndex: "costoProyectado",
                      key: "costoProyectado",
                      align: "right",
                      render: (costo) => dineroDisabledMask(costo || 0),
                    },
                  ]}
                  style={{ marginBottom: 10 }}
                />
              )}
            </>
          )}
        </ModalItem>
        <ElegirLotes
          visible={this.state.loteSeleccionVisible}
          insumoId={this.state.loteSeleccionActual?.insumoId}
          proyectoId={this.state.loteSeleccionActual?.proyectoId}
          cantidad={this.state.loteSeleccionActual?.cantidad}
          cerrarElegirLotes={this.onElegirLotesCerrado}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoCancelarRecepcionOrdenDeCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a4c67bd2bb956249c8716fc"
      )?.activado,
    permisoAccesoMovimientosInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69fe8ef5d4eff74041f388f0"
      )?.activado,
    permisoVerMovimientosInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69fe8f1bd4eff74041f388f1"
      )?.activado,
  };
};

export default connect(mapStateToProps)(RecepcionesOrdenDeCompra);
